export const AUTH_START = "AUTH_START";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAIL = "AUTH_FAIL";
export const AUTH_LOGOUT = "AUTH_LOGOUT";

export const SET_AUTH_REDIRECT_PATH = "SET_AUTH_REDIRECT_PATH";

export const SEARCH_PRODUCT_ID_START = "SEARCH_PRODUCT_ID_START";
export const SEARCH_PRODUCT_ID = "SEARCH_PRODUCT_ID";
export const SEARCH_PRODUCT_ID_SUCCESS = "SEARCH_PRODUCT_ID_SUCCESS";
export const SEARCH_PRODUCT_ID_FAIL = "SEARCH_PRODUCT_ID_FAIL";

export const RESET_SEARCH_STORE = "RESET_SEARCH_STORE";
export const RESET_GENERATE_ID_STORE = "RESET_GENERATE_ID_STORE";
export const RESET_ADMIN_PORTAL_STORE = "RESET_ADMIN_PORTAL_STORE";
export const RESET_USER_STORE = "RESET_USER_STORE";

export const GENERATE_ID_EMAIL_START = "GENERATE_ID_EMAIL_START";
export const GENERATE_ID_EMAIL = "GENERATE_ID_EMAIL";
export const GENERATE_ID_EMAIL_SUCCESS = "GENERATE_ID_EMAIL_SUCCESS";
export const GENERATE_ID_EMAIL_FAIL = "GENERATE_ID_EMAIL_EMAIL";

export const GENERATE_ID_DOWNLOAD_START = "GENERATE_ID_DOWNLOAD_START";
export const GENERATE_ID_DOWNLOAD = "GENERATE_ID_DOWNLOAD";
export const GENERATE_ID_DOWNLOAD_SUCCESS = "GENERATE_ID_DOWNLOAD_SUCCESS";
export const GENERATE_ID_DOWNLOAD_FAIL = "GENERATE_ID_DOWNLOAD_FAIL";

export const DOWNLOAD_FILE_START = "DOWNLOAD_FILE_START";
export const DOWNLOAD_FILE = "DOWNLOAD_FILE";
export const DOWNLOAD_FILE_SUCCESS = "DOWNLOAD_FILE_SUCCESS";
export const DOWNLOAD_FILE_FAIL = "DOWNLOAD_FILE_FAIL";

export const SORT_PARAMS_START = "SORT_PARAMS_START";
export const SORT_PARAMS = "SORT_PARAMS";
export const SORT_PARAMS_SUCCESS = "SORT_PARAM_SUCCESS";
export const SORT_PARAMS_FAIL = "SORT_PARAM_FAIL";

export const SHOW_USER_GENERATION_HISTORY_START = "SHOW_USER_GENERATION_HISTORY_START";
export const SHOW_USER_GENERATION_HISTORY = "SHOW_USER_GENERATION_HISTORY";
export const SHOW_USER_GENERATION_HISTORY_SUCCESS = "SHOW_USER_GENERATION_HISTORY_SUCCESS";
export const SHOW_USER_GENERATION_HISTORY_FAIL = "SHOW_USER_GENERATION_HISTORY_FAIL";

//ADMIN PORRTAL REDUX CONSTANTS

export const LOAD_VIOME_TESTS_START = "LOAD_VIOME_TESTS_START";
export const LOAD_VIOME_TESTS = "LOAD_VIOME_TESTS";
export const LOAD_VIOME_TESTS_SUCCESS = "LOAD_VIOME_TESTS_SUCCESS";
export const LOAD_VIOME_TESTS_FAIL = "LOAD_VIOME_TESTS_FAIL";

export const LOAD_VIOME_KITS_START = "LOAD_VIOME_KITS_START";
export const LOAD_VIOME_KITS = "LOAD_VIOME_KITS";
export const LOAD_VIOME_KITS_SUCCESS = "LOAD_VIOME_KITS_SUCCESS";
export const LOAD_VIOME_KITS_FAIL = "LOAD_VIOME_KITS_FAIL";

//KIT OPERATION REDUX CONSTANTS
export const CREATE_VIOME_KIT_START = "CREATE_VIOME_KIT_START";
export const CREATE_VIOME_KIT = "CREATE_VIOME_KIT";
export const CREATE_VIOME_KIT_SUCCESS = "CREATE_VIOME_KIT_SUCCESS";
export const CREATE_VIOME_KIT_FAIL = "CREATE_VIOME_KIT_FAIL";

export const DELETE_VIOME_KIT_START = "DELETE_VIOME_KIT_START";
export const DELETE_VIOME_KIT = "DELETE_VIOME_KIT";
export const DELETE_VIOME_KIT_SUCCESS = "DELETE_VIOME_KIT_SUCCESS";
export const DELETE_VIOME_KIT_FAIL = "DELETE_VIOME_KIT_FAIL";

export const UPDATE_VIOME_KIT_START = "UPDATE_VIOME_KIT_START";
export const UPDATE_VIOME_KIT = "UPDATE_VIOME_KIT";
export const UPDATE_VIOME_KIT_SUCCESS = "UPDATE_VIOME_KIT_SUCCESS";
export const UPDATE_VIOME_KIT_FAIL = "UPDATE_VIOME_KIT_FAIL";
//TEST OPERATIONS REDUX CONSTANTS
export const CREATE_VIOME_TEST_START = "CREATE_VIOME_TEST_START";
export const CREATE_VIOME_TEST = "CREATE_VIOME_TEST";
export const CREATE_VIOME_TEST_SUCCESS = "CREATE_VIOME_TEST_SUCCESS";
export const CREATE_VIOME_TEST_FAIL = "CREATE_VIOME_TEST_FAIL";

export const UPDATE_VIOME_TEST_START = "UPDATE_VIOME_TEST_START";
export const UPDATE_VIOME_TEST = "UPDATE_VIOME_TEST";
export const UPDATE_VIOME_TEST_SUCCESS = "UPDATE_VIOME_TEST_SUCCESS";
export const UPDATE_VIOME_TEST_FAIL = "UPDATE_VIOME_TEST_FAIL";
